<div class="content-header">
    <h2>Demanda electrónica</h2>
</div>

<div class="form-section">
    <h3 class="h3-title">Selección de OCC:</h3>

    <oaj-occ-filter (FilterSelect)="FiltroSeleccionado($event)"></oaj-occ-filter>
  <form [formGroup]="DemandForm">
<div class="row">
        <div class="col-6">
            <div class="form-group">
                <label for="tipo-filtro">Promovente:</label>
               <!--  <input type="text" id="promovente"  formControlName="promovente"> -->
                  <textarea class="form-control" id="promovente" 
                    formControlName="promovente"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="6">
                        placeholder="Ingrese el nombre del promovente.">
                    </textarea>
            </div>
        </div>
    </div>
     <br>
  </form>
    

</div>
<div class="document-upload-section">
    <h3>Ingresar Demanda, Solicitud o Escrito Inicial:</h3>
    <p class="formats-info">Formatos válidos de archivo: {{sFormatos}}</p>

    <div class="aviso-frame">
        <p>
            Al ingresar el documento, verificar que el nombre del archivo no cuente con signos de puntuación,
            admiración
            o caracteres especiales como apóstrofes, guiones, etc.
        </p>
        <p>
            Nota: El tamaño límite de los archivos debe ser 40 MB por documento, mismos que en su conjunto no deberán de exceder de 360 MB por envío.
        </p>
    </div>
    <div class="row mt-3 justify-content-end">
        <div class="col-12 col-sm-auto">
            <!-- <button class="btn btn-file" (click)="cargaArchivo()">Seleccionar archivos</button> -->
            <button class="btn btn-file" (click)="openWindowFirma()">Seleccionar archivos</button>
        </div>
    </div>
    <div class="row">
        <div class="col-12 col-sm-auto">
            <div class="center">
                <oaj-loader-itx [loading]="isLoadingFile" [sMensaje]="sMensajeLoad" #loaderSpinner></oaj-loader-itx>
            </div>
            @if(!isLoadingFile && lstDocumentos.length>0){
            <oaj-lista-archivos-itx class="form-control" [archivos]="lstDocumentos" [verBorrar]="true"
                (BorraDoc)="EliminarDocumentosPantalla($event)" [verPrevisualizar]="true" 
                [OcultaSystemName]="true" [downloagOrg]="true">
            </oaj-lista-archivos-itx>
            }
        </div>
    </div>
    <oaj-alert-itx></oaj-alert-itx>
    <div class="row mt-3 justify-content-end"></div>
    <hr>
    <div class="row mt-3 justify-content-end">
         <!--   <button class="btn btn-envio" (click)="getAcuse(4)">ACUSE </button>  -->
        <div class="col-12 col-sm-auto">
            <button type="submit" class="btn btn-envio" [disabled]="loading" (click)="EnviarDemanda()">
                @if(!loading){
                <span>Enviar Demanda</span>
                }
                @else{
                <span class="d-flex align-items-center justify-content-center">
                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Enviando...
                </span>
                }
            </button>
        </div>

    </div>

</div>